import {
  ExternalRouteRef,
  RouteRef,
  SubRouteRef,
  createExternalRouteRef,
  createRouteRef,
} from '@backstage/core-plugin-api';

import { createPageRoute } from '@spotify/confidence-common-react';

export enum RoutesIds {
  issues = 'issues',
  issue = 'issue',
  observations = 'observations',
  themes = 'themes',
}

enum ExternalRoutesIds {
  chat = 'chat',
  github = 'github',
}

export const issuesRouteRef = createPageRoute({
  id: 'issue-index',
  page: { title: 'Loop' },
});

export const rootRouteRef = issuesRouteRef;

export const observationsRouteRef = createPageRoute({
  id: 'observation-index',
  route: { path: '/observations', parent: rootRouteRef },
  page: { title: 'Observations' },
});

export const issueRouteRef = createPageRoute({
  id: RoutesIds.issue,
  route: { path: '/:id', parent: rootRouteRef },
  page: { title: 'Issue' },
});

export const themesRouteRef = createRouteRef({
  id: RoutesIds.themes,
});

export const chatRouteRef = createExternalRouteRef({
  id: ExternalRoutesIds.chat,
  params: ['id'],
  optional: true,
});

export const githubRouteRef = createExternalRouteRef({
  id: ExternalRoutesIds.github,
  optional: true,
});

export const Routes = {
  issues: issuesRouteRef,
  issue: issueRouteRef,
  observations: observationsRouteRef,
  themes: themesRouteRef,
} satisfies Record<RoutesIds, SubRouteRef | RouteRef>;

export const ExternalRoutes = {
  chat: chatRouteRef,
  github: githubRouteRef,
} satisfies Record<ExternalRoutesIds, ExternalRouteRef>;
